import dayjs from "./dayjs.js";

// live code 验证规则
export const getCode = () => {
  const hour = dayjs().format("HH");
  const yesterday = dayjs().subtract(1, "day");
  let str1 = hour >= 15 ? dayjs().format("DD") : dayjs(yesterday).format("DD"); // 15点后取当天的DD 15点前取昨天的DD

  let str2 = hour < 15 && dayjs().day() == 1 ? filterDay(yesterday) : filterDay(dayjs()); // 周一未到15点 code为前一天

  let code_string = `${str1}${str2}`;
  let str3 = code_string % 9533;
  let str4 = Math.floor(code_string / 9533);
  let str5 = `${str4}${str3}`;

  return str5.slice(-4);
};

const filterDay = (date) => {
  let str1 = dayjs(date).startOf("week").format("MM"); // 当前周开始所在月

  let week = dayjs(date).week();
  let str2 = week < 10 ? `0${week}` : week; // 当前今年第几周

  let str3 = dayjs(date).startOf("week").format("DD"); // 当前周开始所在日期DD

  return `${str1}${str2}${str3}`;
};

// 验证pc or mobile
export const isMobile = () => {
  if (
    window.navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
  ) {
    return true; // 移动端
  } else {
    if (window.navigator.userAgent.match(/miniprogram/i)) {
      return true; // pc小程序环境
    }else{
      return false; // PC端
    }
  }
};

// 防抖
export const debounce = (fn, time) => {
  let timer = null;
  return (...args) => {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.call(context, ...args);
    }, time);
  };
};

export const generateRandomId = (length) => {
  const characters = "0123456789abcdef";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

export const GetUrlParam = (paraName) => {
  var url = document.location.toString();
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
};

// 将颜色值和透明度转换为 RGBA 颜色字符串
export const opacityToRgbaColor = (color, opacity) => {
  const hex = color || "#fff";
  const _opacity = opacity === null || opacity === undefined || opacity === "" ? 1 : opacity;
  return hexToRgba(hex, _opacity) || "transparent";
};

// 辅助函数：将 hex 转换为 rgba
export const hexToRgba = (hex, opacity) => {
  hex = hex.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

// 组件的px转vw
export const convertToVw = (pxValue, width) => {
  if (isMobile()) {
    const scale = (pxValue / (width || 375)).toFixed(2);
    return `${scale * 100}vw`;
  } else {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1280) {
      return `${(pxValue * 1.5).toFixed(2)}px`;
    } else if (screenWidth >= 1024) {
      return `${(pxValue * 1.3).toFixed(2)}px`;
    } else if (screenWidth >= 768) {
      return `${(pxValue * 1.1).toFixed(2)}px`;
    } else {
      return `${pxValue}px`; // 默认宽度
    }
  }
};

// 将日期字符串格式化为 YYYYMMDD 格式的字符串
export const formatDate = (date, delimiter) => {
  const [year, month, day] = date.split(delimiter);
  const dateObj = new Date(year, month - 1, day); // 创建 Date 对象，注意月份需要减 1
  const yearStr = dateObj.getFullYear().toString().padStart(4, "0");
  const monthStr = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  const dayStr = dateObj.getDate().toString().padStart(2, "0");
  return `${yearStr}${monthStr}${dayStr}`; // 将年、月、日拼接成 YYYYMMDD 格式的字符串
};

// 将 YYYYMMDD 格式的日期字符串转换为 Unix 时间戳（以秒为单位）
export const dateToUnixTimestamp = (date) => {
  const _date = date.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1/$2/$3");
  return new Date(_date).getTime() / 1000;
};

// 指定日期加天数
export const dateAdd = (date, step) => {
  const _date = new Date(date); // 创建 Date 对象
  _date.setDate(_date.getDate() + step);
  return _date.toLocaleDateString();
};

// browserTrackSDK数据上报unionId封装
export const setSDKUnionId = (data) => {
  Object.entries(data || {}).forEach(([key, value]) => {
    if (key === "uid" && value) window["browserTrackSDK"]?.login(value);
    if (key === "unionId" && value) window["browserTrackSDK"]?.setUnionId(value);
    if (key === "token" && value) window["browserTrackSDK"]?.loginByAppToken(value);
  });
};
